import { Grid } from '@material-ui/core';
import { Field, useFormikContext, FormikValues } from 'formik';
import React from 'react';
import { ExtendedRuleDefinition } from '../../gen/api/api';
import { getRuleDisplayConfig } from '../../shared/settings/config';
import RuleFactory from './RuleFactory';
import { EffectiveFactBehaviourEnum } from '../ConfigurationForm/ConfigurationFormSchema';
import useFieldHelpers from '../../helpers/fieldHelper';

const { getEffectiveFactBehaviour } = useFieldHelpers();

export interface RulesComponentProps {
    readonly ruleDefinitions: ExtendedRuleDefinition[];
    readonly disabled: boolean;
}

const RulesComponent = ({ ruleDefinitions, disabled, ...props }: RulesComponentProps) => {
    const { values } = useFormikContext<FormikValues>();

    const effectiveFactBehaviour = new Map();

    ruleDefinitions.forEach(function (ruleDefinition) {
        Object.values(ruleDefinition.factDefinitions).forEach(function (factDefinition) {
            effectiveFactBehaviour.set(factDefinition, getEffectiveFactBehaviour(factDefinition, values));
        });
    });

    const rules = ruleDefinitions
        .filter((ruleDefinition) => {
            return Object.values(ruleDefinition.factDefinitions).some(
                (factDefinition) => effectiveFactBehaviour.get(factDefinition) != EffectiveFactBehaviourEnum.IGNORED,
            );
        })
        .map((ruleDefinition) => [ruleDefinition, getRuleDisplayConfig(ruleDefinition.ruleCode)])
        .sort(
            ([_ruleDefinition1, ruleConfig1], [_ruleDefinition2, ruleconfig2]) => ruleConfig1.order - ruleconfig2.order,
        )
        .map(([ruleDefinition, ruleConfig]) => {
            return (
                <Field
                    key={'rules'.concat(ruleDefinition.ruleCode)}
                    width={ruleConfig.width}
                    ruleConfig={ruleConfig}
                    ruleDefinition={ruleDefinition}
                    ruleCode={ruleDefinition.ruleCode}
                    disabled={disabled}
                    component={RuleFactory({ ruleConfig, props })}
                />
            );
        });

    return (
        <Grid container spacing={1}>
            {rules}
        </Grid>
    );
};

export default RulesComponent;
